import { Subject } from 'rxjs';

/**
 * The backend's PolicyGateFilter answers 412 with this code in the JSON body while the user has an unaccepted
 * policy version. Matching on the code, not the status, is required: the MFA gate also answers 412. This string is a
 * wire contract shared with the backend and the mobile app; it must not be renamed on one side only.
 */
export const POLICY_ACCEPTANCE_REQUIRED_CODE = 'POLICY_ACCEPTANCE_REQUIRED';

/** What a person is told when a streaming request is refused by the policy gate. */
export const POLICY_ACCEPTANCE_REQUIRED_MESSAGE =
  'Please accept the updated Terms of Service and Privacy Policy to continue. The prompt will appear, or reload the page.';

const refused = new Subject<void>();

/**
 * Fires when a request was refused by the policy gate, so the app shell re-checks and shows the acceptance dialog. A
 * request made with `fetch` (the streaming helper) never reaches the HTTP interceptor, and the interceptor itself
 * swallows this 412 to keep alerts quiet, so without this nothing re-opens the dialog when a new version arrives
 * while a page is open. A plain module-level subject, not DI: the stream helper is a function with no injector.
 */
export const policyGateRefused$ = refused.asObservable();

export function signalPolicyAcceptanceRequired(): void {
  refused.next();
}
